import WeChatLoginBtn from '../features/user/components/WeChatLoginBtn'

export default function LoginPage() {
    return (
        <div>
            <h1 className="mb-4">登录</h1>
            <div>
                <WeChatLoginBtn />
            </div>
        </div>
    )
}
